
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetoashtavinayak() {



    const cardData =
    {
        keyword: 'Pune To Ashtavinayak Darshan Cab',
        heading: 'Mauli Cabs:  Pune To Ashtavinayak Darshan Cab',
        headingDescription: 'Mauli Cabs offers reliable and comfortable Pune to Ashtavinayak Darshan cab services, ensuring a smooth and spiritual journey to the sacred Ashtavinayak temples. Whether you are on a religious pilgrimage or a peaceful family trip, we provide a variety of vehicles including sedans, SUVs, and premium cars. With professional drivers, transparent pricing, no hidden charges, and a commitment to safety, Mauli Cabs guarantees a hassle-free and enriching experience on your Ashtavinayak Darshan journey.',

        top: 'Top Places to Visit in Ashtavinayak with Mauli Cabs',

"topPlaces": [
    {
        "title": "Moreshwar Temple (Morgaon)",
        "description": "Located in Morgaon, near Pune, Moreshwar Temple is the first and one of the most revered of the Ashtavinayak temples. It is dedicated to Lord Ganesha, who is believed to have granted the boon of removing obstacles."
    },
    {
        "title": "Siddhivinayak Temple (Siddhatek)",
        "description": "Siddhivinayak Temple, located in Siddhatek near Pune, is dedicated to Lord Ganesha. The temple is unique for its historical significance and is believed to fulfill the wishes of devotees who worship with devotion."
    },
    {
        "title": "Ballaleshwar Temple (Pali)",
        "description": "Located in Pali, this temple is known for its unique idol of Lord Ganesha, with his hands in a raised position. It is an important pilgrimage site for those seeking blessings for prosperity."
    },
    {
        "title": "Varadvinayak Temple (Mahad)",
        "description": "The Varadvinayak Temple in Mahad is renowned for its peaceful atmosphere and significance in the Ashtavinayak pilgrimage circuit. Lord Ganesha here is believed to be the remover of all obstacles."
    },
    {
        "title": "Chintamani Vinayak Temple (Theur)",
        "description": "Located in Theur, Chintamani Vinayak Temple is known for its ancient and divine idol of Lord Ganesha. It is believed that worshipping here helps in overcoming mental worries and problems."
    },
    {
        "title": "Girijatmaj Temple (Lenyadri)",
        "description": "Girijatmaj Temple in Lenyadri is situated on a hill and offers a beautiful view of the surrounding mountains. The temple is significant for the rock-cut caves around it and the unique idol of Lord Ganesha."
    },
    {
        "title": "Vigneshwar Temple (Ozar)",
        "description": "Located in Ozar, Vigneshwar Temple is dedicated to Lord Ganesha, who is believed to have removed the obstacles for devotees who worship here. The temple is famous for its religious significance."
    },
    {
        "title": "Mahaganapati Temple (Ranjangaon)",
        "description": "The Mahaganapati Temple in Ranjangaon is one of the Ashtavinayak temples and holds a special place in the hearts of devotees. The temple is believed to grant strength and protection from all evils."
    }
],

"services": [
    {
        "name": "Pune to Ashtavinayak Darshan Cab Service",
        "description": "Mauli Cabs offers reliable and comfortable cab services for your Ashtavinayak Darshan journey from Pune. Experience a peaceful pilgrimage with professional drivers and well-maintained vehicles."
    },
    {
        "name": "Book Pune to Ashtavinayak Taxi",
        "description": "Book your taxi from Pune to Ashtavinayak temples with Mauli Cabs. We ensure a smooth, safe, and timely journey to all the sacred Ashtavinayak temples."
    },
    {
        "name": "Affordable Pune to Ashtavinayak Darshan Cab",
        "description": "Mauli Cabs offers affordable taxi services for your Ashtavinayak Darshan journey from Pune. Get a comfortable and budget-friendly ride to the holy temples."
    },
    {
        "name": "Private Taxi for Ashtavinayak Darshan from Pune",
        "description": "Choose Mauli Cabs for a private taxi service to Ashtavinayak Darshan from Pune. Enjoy a personalized, peaceful, and private pilgrimage experience."
    },
    {
        "name": "Ashtavinayak Pilgrimage by Cab from Pune",
        "description": "Mauli Cabs offers convenient and comfortable cab services for your Ashtavinayak pilgrimage. Let us take you on a smooth journey to the revered temples of Ashtavinayak."
    },
    {
        "name": "Pune to Ashtavinayak Darshan One-Way or Round Trip",
        "description": "Whether you're looking for a one-way ride or a round trip to Ashtavinayak, Mauli Cabs offers flexible taxi services to suit your travel needs."
    },
    {
        "name": "Comfortable Taxi Ride for Ashtavinayak Darshan",
        "description": "Travel comfortably to the Ashtavinayak temples from Pune with Mauli Cabs. Our vehicles are air-conditioned, clean, and comfortable, ensuring a pleasant journey."
    },
    {
        "name": "Group Travel to Ashtavinayak Darshan",
        "description": "Mauli Cabs offers spacious vehicles for group travel to Ashtavinayak Darshan. Enjoy the pilgrimage with family or friends, all in comfort and style."
    },
    {
        "name": "Luxury Taxi for Ashtavinayak Darshan Tour",
        "description": "Travel in luxury to Ashtavinayak Darshan with Mauli Cabs. Our premium taxis offer top-tier comfort, excellent service, and an unforgettable travel experience."
    },
    {
        "name": "Pune to Ashtavinayak Sightseeing by Taxi",
        "description": "Mauli Cabs offers sightseeing services for your Ashtavinayak tour. Our professional drivers will guide you through the temples, ensuring you have a peaceful and informative journey."
    }
],

"tableData": [
    ["Pune to Ashtavinayak Darshan Cab Service", "Book Pune to Ashtavinayak Taxi"],
    ["Affordable Pune to Ashtavinayak Darshan Cab", "Private Taxi for Ashtavinayak Darshan from Pune"],
    ["Ashtavinayak Pilgrimage by Cab from Pune", "Pune to Ashtavinayak Darshan One-Way or Round Trip"],
    ["Comfortable Taxi Ride for Ashtavinayak Darshan", "Group Travel to Ashtavinayak Darshan"],
    ["Luxury Taxi for Ashtavinayak Darshan Tour", "Pune to Ashtavinayak Sightseeing by Taxi"]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs ensures reliable and timely service for your Pune to Ashtavinayak Darshan Cab. Our drivers are committed to picking you up on time and ensuring that you visit all the Ashtavinayak temples as per your itinerary, without any delays."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedcription": "We provide a range of vehicles for your Ashtavinayak Darshan, from sedans to SUVs and premium cars. All our vehicles are air-conditioned, spacious, and designed for comfort, allowing you to enjoy your journey across the sacred sites with ease."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are familiar with the routes to all the Ashtavinayak temples. They ensure a smooth and safe journey while following the best routes and traffic conditions, so you can focus on your spiritual experience."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable and transparent pricing for your Pune to Ashtavinayak Darshan Cab. We believe in clear, upfront pricing with no hidden charges, so you can enjoy a stress-free trip without worrying about unexpected costs."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Safety is our priority. All our vehicles are regularly serviced and come equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure a secure and pleasant journey to the Ashtavinayak temples."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Ashtavinayak Darshan Cab. Whether you need an early morning pickup or a late-night return, our customer service team is ready to assist you with your booking anytime."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Ashtavinayak Darshan Cab with Mauli Cabs is simple and quick. You can easily book your ride online through our website or mobile app, or contact our customer service team for personalized assistance with your journey."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether you're visiting all eight Ashtavinayak temples or customizing your trip, Mauli Cabs offers tailored travel packages for your Darshan journey. Let us know your preferences, and we’ll design a plan that suits your needs."
    }
]










    }



    const faqData = [
        {
            question: 'How do I book a cab for the Pune to Ashtavinayak Darshan with Mauli Cabs?',
            answer: 'Booking your cab for Ashtavinayak Darshan is simple! You can use our website or mobile app to book. Just enter Pune as your pickup location and select the Ashtavinayak temples you want to visit. Alternatively, you can call our support team for assistance in planning your Darshan tour.',
        },
        {
            question: 'What temples are included in the Pune to Ashtavinayak Darshan?',
            answer: 'The Ashtavinayak Darshan tour includes visits to the eight famous Ganesh temples around Pune. These temples are located in different places like Morgaon, Siddhatek, Theur, Lenyadri, and more. We offer both one-day and two-day tour packages based on your preference.',
        },
        {
            question: 'What types of cabs are available for the Ashtavinayak Darshan?',
            answer: 'Mauli Cabs offers a variety of vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. Choose the vehicle that fits your comfort and space requirements for the Darshan tour.',
        },
        {
            question: 'Is the fare for the Ashtavinayak Darshan fixed?',
            answer: 'Yes, the fare for the Ashtavinayak Darshan is fixed and transparent. It includes tolls, taxes, and driver charges. You will know the total fare upfront, with no hidden costs.',
        },
        {
            question: 'How long does the Pune to Ashtavinayak Darshan tour take?',
            answer: 'The tour duration can vary depending on the number of temples you wish to visit. Typically, the tour lasts 1 to 2 days. We offer flexible tour packages to suit your schedule.',
        },
        {
            question: 'Are your drivers experienced with the Ashtavinayak Darshan route?',
            answer: 'Yes, all Mauli Cabs drivers are experienced, professional, and familiar with the Ashtavinayak Darshan route. You can expect a safe, smooth, and comfortable journey during your religious tour.',
        },
        {
            question: 'Can I customize my Ashtavinayak Darshan itinerary?',
            answer: 'Absolutely! We offer customizable Ashtavinayak Darshan tour packages. You can choose which temples to visit, the duration of your trip, and any other stops along the way. We tailor the itinerary to fit your preferences.',
        },
        {
            question: 'Are the cabs air-conditioned and well-maintained?',
            answer: 'Yes, all our cabs are air-conditioned and well-maintained for a comfortable and clean journey. We prioritize hygiene and ensure that your ride is pleasant throughout the Darshan tour.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. We offer a flexible cancellation policy through our website or app, and our customer support team is always available to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Ashtavinayak Darshan tour?',
            answer: 'Mauli Cabs offers competitive pricing, professional drivers, a range of vehicle options, and flexible tour packages. We ensure a peaceful and hassle-free Ashtavinayak Darshan experience.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Vinay Kulkarni",
            position: "Devotee",
            text: "Our Ashtavinayak Darshan tour was a truly spiritual experience. The driver was well-versed with the route, and the car was clean and comfortable. Thank you Mauli Cabs for making our religious journey so peaceful!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Shubhangi Joshi",
            position: "Spiritual Traveler",
            text: "I had an amazing experience on the Ashtavinayak Darshan tour with Mauli Cabs. The ride was smooth, and the driver was very accommodating and professional. The temples were magnificent, and the journey was so comfortable. Highly recommend!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Ashtavinayak Darshan Cab by Mauli Cabs",
        "description": "Mauli Cabs offers reliable and affordable cab services from Pune for the Ashtavinayak Darshan pilgrimage. Choose from private, luxury, or group taxis for a comfortable one-way or round-trip journey to the Ashtavinayak temples, with 24x7 online booking available.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "6200"
        }
      };
      
    
      


    return (
        <div>
            <GTag/>


<Helmet>
        <title>Pune to Ashtavinayak Darshan Cab | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book Pune to Ashtavinayak Darshan cab with Mauli Cabs. Affordable, comfortable, and reliable taxi options for pilgrimage tours. Private, luxury, and group travel with one-way and round-trip bookings available 24x7."
        />
        <meta
          name="keywords"
          content="Pune to Ashtavinayak Darshan cab service, Book Pune to Ashtavinayak taxi, Affordable Pune to Ashtavinayak Darshan cab, Private taxi for Ashtavinayak Darshan from Pune, Ashtavinayak pilgrimage by cab from Pune, Pune to Ashtavinayak Darshan one-way or round trip, Comfortable taxi ride for Ashtavinayak Darshan, Group travel to Ashtavinayak Darshan, Luxury taxi for Ashtavinayak Darshan tour, Pune to Ashtavinayak sightseeing by taxi"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/11.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoashtavinayak;